<div class="mb-1 catalog-item-box">
  <app-product-image #productImage [height]="produtoHeight" [product]="product"
    [quantidadeCarrinho]="quantidadeCarrinho"
    [produtoDescrHeight]="produtoDescrHeight" (onAdd)="addCart($event)" (redirectTo)="redirectTo.emit($event)">
  </app-product-image>

  <div class="product-quantity-input mt-1" [style.height.px]="50">
    <app-product-quantity-input *ngIf="product.preco" #productQtyInput [product]="product"
      [produtoDescrHeight]="produtoDescrHeight" (onAdd)="addCart($event)">
    </app-product-quantity-input>
  </div>

  <div class="descr" [style.height.px]="produtoDescrHeight" [style.font-size.rem]="produtoDescrFontSize">
    {{ product.descricao }}
    <!-- {{
      product.descricao.length > produtoDescrLen
        ? (product.descricao | slice : 0 : produtoDescrLen) + "..."
        : product.descricao
    }} -->
  </div>

  <div class="ref" [style.font-size.rem]="produtoDescrFontSize" [style.height.px]="produtoDescrHeight">
    <span *ngIf="!product.estoque && SITE.mostraDisponivelCatalogo" class="badge badge-secondary"
      [style.font-size.rem]="produtoIndispFontSize" i18n>Indisponível</span>
    Ref. {{ product.referencia }}
  </div>
  <div *ngIf="mostraPreco">
    <div *ngIf="product.precopromocional; else elseBlockPreco">
      <span i18n>De:</span>
      <span class="moneyOff" [style.font-size.rem]="produtoDescrFontSize" i18n>
        R${{ product.preco | currency : "BRL" :
        "" }}
        </span>
      <span i18n class="ml-2">Por:</span>
      <span class="money1 ml-1" [style.font-size.rem]="produtoDescrFontSize" i18n>R${{ product.precopromocional |
        currency : "BRL" : "" }}</span>
    </div>
    <ng-template #elseBlockPreco>
      <div >
        <span *ngIf="product.preco" class="money" [style.font-size.rem]="produtoDescrFontSize" i18n>R${{ getPrice() | currency : "BRL" : ""
          }}</span>
      </div>
    </ng-template>
  </div>
  <div *ngIf="((mostraPreco && product.precosugerido) || showStock) && userLogged" class="row product-info-box"
    [style.backgroundColor]="SITE.backgroundColorSliderSuperior">
    <div *ngIf="mostraPreco && product.precosugerido" class="col-md-6">
      <span class="" [style.font-size.rem]="produtoIndispFontSize" i18n>Preço Sugerido<br />
        R${{ product.precosugerido | currency : "BRL" : "" }}
      </span>
    </div>
    <div *ngIf="showStock" class="col-md-6">
      <span *ngIf="this.product.estoque >= 0; else estoqueIndisponivel" [style.font-size.rem]="produtoIndispFontSize"
        i18n>Estoque<br />
        {{ stock }}
      </span>
      <ng-template #estoqueIndisponivel>
        <span *ngIf="validaEstoque; else naovalida" [style.font-size.rem]="produtoIndispFontSize" i18n>Indisponível
        </span>
        <ng-template #naovalida>
          <span [style.font-size.rem]="produtoIndispFontSize">{{
            config.descricao_estoque_indisponivel
            }}</span>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>